<div class="container py-3">

    <div class="row">
        <div class="col-6">
            <h1>Profiel</h1>
            @let assignments = LocalStorage.user?.assignments ?? [];
            @let currentAssignment = UserAssignment.current(assignments);

            <table class="table">
                <tbody>
                    <tr>
                        <th>Naam</th>
                        <td>{{LocalStorage.user?.name}}</td>
                    </tr>
                    <tr>
                        <th>E-mailadres</th>
                        <td>{{LocalStorage.user?.email}}</td>
                    </tr>
                    <tr>
                        <th>Parttime percentage</th>
                        <td>{{currentAssignment ? (currentAssignment.part_time_rate | percent) : '—'}}</td>
                    </tr>
                    <tr>
                        <th>In dienst sinds</th>
                        <td>{{LocalStorage.user?.employment_start | date:'EEEE d MMMM yyyy'}}</td>
                    </tr>
                    <tr>
                        <th>Uit dienst</th>
                        <td>{{LocalStorage.user?.employment_end ? (LocalStorage.user?.employment_end | date:'EEEE d MMMM yyyy') : '—'}}</td>
                    </tr>
                    <tr>
                        <th>Totaal gewerkte tijd</th>
                        <td>{{totals() ? (totals().worked_minutes | minutes:false) + ' uur' : '…'}}</td>
                    </tr>
                    <tr>
                        <th>Totaal opgenomen vakantie</th>
                        <td>{{totals() ? (totals().vacation_minutes | minutes:false) + ' uur' : '…'}}</td>
                    </tr>
                    <tr>
                        <th>Balans</th>
                        <td [class.text-danger]="totals()?.balance_minutes < 0">{{totals() ? (totals().balance_minutes | minutes:false) + ' uur' : '…'}}</td>
                    </tr>
                    <tr>
                        <th>Rollen</th>
                        <td>
                            @for (role of LocalStorage.user?.roles; track role.key) {
                                <span class="badge bg-secondary me-1">{{role.name}}</span>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>

            @if (assignments.length) {
                <h2 class="h5">Parttime percentage per periode</h2>
                <table class="table">
                    <thead>
                        <tr>
                            <th>Van</th>
                            <th>Tot en met</th>
                            <th>Percentage</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (assignment of assignments; track assignment.id) {
                            <tr [class.fw-bold]="assignment.id === currentAssignment?.id">
                                <td>{{assignment.begin_date | date:'d MMMM yyyy'}}</td>
                                <td>{{assignment.end_date ? (assignment.end_date | date:'d MMMM yyyy') : 'lopend'}}</td>
                                <td>{{assignment.part_time_rate | percent}}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            }

            @if (totals()?.per_year.length) {
                <h2 class="h5">Per jaar</h2>
                <table class="table">
                    <thead>
                        <tr>
                            <th>Jaar</th>
                            <th>Vakantie</th>
                            <th>Ziek</th>
                            <th>Balans</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (year of totals().per_year; track year.year) {
                            <tr>
                                <td>{{year.year}}</td>
                                <td>{{year.vacation_minutes | minutes:false}} uur</td>
                                <td>{{year.sick_minutes | minutes:false}} uur</td>
                                <td [class.text-danger]="year.balance_minutes < 0">{{year.balance_minutes | minutes:false}} uur</td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>
        <div class="col-6">
            <h1>E-mailhandtekening</h1>
            <mat-checkbox [formControl]="showOwnMail" class="mb-3">
                Toon eigen e-mailadres
            </mat-checkbox>
            <frame>

                @let linkStyle = "text-decoration: underline; color: #313840;";
                @let iconStyle = "border: none; color: #2AE7AC; font-size: 20px; text-align: center; padding-right: 15px;";
                @let firstName = `${LocalStorage.user?.name.split(' ')[0]}`.toLowerCase().trim();

                <table cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; border: none; font-size:15px;color:rgb(47,56,65);font-family:'Segoe UI', Helvetica, Arial, sans-serif">
                    <tbody>
                        <tr style="font-size:17px;">
                            <td colspan="2" style="border: none; line-height: 1.8" valign="top" align="left">
                                <span>Met vriendelijke groet,</span><br>
                                <b>{{LocalStorage.user?.name}}</b>
                            </td>
                        </tr>
                        <tr>
                            @if(base64Image()) {
                                <td colspan="3" style="border: none;">
                                    &nbsp;&nbsp;&nbsp;<br>
                                    <img width="150" alt="Codalt logo" height="34"
                                         [src]="base64Image() | safeResourceUrl">
                                    <br>&nbsp;&nbsp;&nbsp;&nbsp;
                                </td>
                            }
                        </tr>
                        <tr style="line-height: 2">
                            <td width="50" style="border: none; {{iconStyle}} font-weight: bold;">
                                ☏&nbsp;
                            </td>
                            <td colspan="2" style="border: none;">
                                <a href="tel:+31855005060" [attr.style]="linkStyle" target="_blank">
                                    085 - 500&nbsp;5060
                                </a>
                            </td>
                        </tr>
                        <tr style="line-height: 2">
                            <td width="50" style="border: none; {{iconStyle}} font-weight: bold;">
                                🗪︎&nbsp;
                            </td>
                            <td colspan="2" style="border: none;">
                                <a href="https://wa.me/31855005060" [attr.style]="linkStyle" target="_blank" title="Contact opnemen via WhatsApp">
                                    085 - 500&nbsp;5060
                                </a>
                            </td>
                        </tr>
                        <tr style="line-height: 2">
                            <td valign="top" style="border: none; {{iconStyle}}">
                                ?&nbsp;
                            </td>
                            <td colspan="2" style="border: none;">
                                <a href="mailto:support@codalt.com" [attr.style]="linkStyle" target="_blank">support@codalt.com</a>
                            </td>
                        </tr>
                        @if (showOwnMail.value) {
                            <tr style="line-height: 2">
                                <td valign="top" style="border: none; {{iconStyle}}">
                                    @&nbsp;
                                </td>
                                <td colspan="2" style="border: none;">
                                    <a href="mailto:{{LocalStorage.user?.email}}" [attr.style]="linkStyle" target="_blank">{{LocalStorage.user?.email}}</a>
                                </td>
                            </tr>
                        }
                        <tr style="line-height: 2">
                            <td [attr.style]="'border: none; ' + iconStyle">
                                ⚑&nbsp;
                            </td>
                            <td style="border: none; line-height: 1.4;">
                                <b>Kopgebouw Dordrecht</b><br>
                                Leerparkpromenade 40<br>
                                3312 KW Dordrecht
                            </td>
                        </tr>
                        <tr style="line-height: 2">
                            <td style="border: none; {{iconStyle}} font-weight: bold;">
                                ⤳&nbsp;
                            </td>
                            <td colspan="2" style="border: none;">
                                <a href="https://codalt.com/?utm_source=signature_{{firstName}}" [attr.style]="linkStyle">codalt.com</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </frame>
        </div>
        <div class="col-6 mb-3">
            <div [class.copied]="urlCopiedOwn()" [class.past-copied]="urlCopiedOwn()" class="url-share mb-3">
                <h4>CRM26 kalender URL - alleen mijn afspraken</h4>
                <p>Dit is een persoonlijke URL. Deel deze niet met derden.</p>
                <div (click)="copyUrlShare(true)" class="d-flex inpholder">
                    <div class="inputs">
                        <div class="animated"><span>{{environment.apiEndpoint | urlPrefixStripping}}</span>/ical/{{LocalStorage.user.calendarUrl}}?onlyMe=true</div>
                        <div class="animated animate"><span>{{environment.apiEndpoint | urlPrefixStripping}}</span>/ical/{{LocalStorage.user.calendarUrl}}?onlyMe=true</div>
                    </div>
                    <div class="button button--primary">{{urlCopiedOwn() ? 'Gekopieerd!' : 'Kopieer URL'}}</div>
                </div>
            </div>
            <div [class.copied]="urlCopied()" [class.past-copied]="urlCopied()" class="url-share">
                <h4>CRM26 kalender URL</h4>
                <p>Dit is een persoonlijke URL. Deel deze niet met derden.</p>
                <div (click)="copyUrlShare()" class="d-flex inpholder">
                    <div class="inputs">
                        <div class="animated"><span>{{environment.apiEndpoint | urlPrefixStripping}}</span>/ical/{{LocalStorage.user.calendarUrl}}</div>
                        <div class="animated animate"><span>{{environment.apiEndpoint | urlPrefixStripping}}</span>/ical/{{LocalStorage.user.calendarUrl}}</div>
                    </div>
                    <div class="button button--primary">{{urlCopied() ? 'Gekopieerd!' : 'Kopieer URL'}}</div>
                </div>
            </div>
        </div>
    </div>

    @if (isManagement) {
        <div class="row">
            <div class="col-12">
                <h1>Overzicht medewerkers</h1>
                @if (overviewRows(); as rows) {
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th rowspan="2">Medewerker</th>
                                    <th class="text-end" rowspan="2">Gewerkt</th>
                                    <th class="text-end" rowspan="2">Balans</th>
                                    @for (year of overviewYears(); track year) {
                                        <th class="text-center" colspan="3">{{year}}</th>
                                    }
                                </tr>
                                <tr>
                                    @for (year of overviewYears(); track year) {
                                        <th class="text-end">Vakantie</th>
                                        <th class="text-end">Ziek</th>
                                        <th class="text-end">Balans</th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                @for (user of rows; track user.user_id) {
                                    <tr>
                                        <td>{{user.name}}</td>
                                        <td class="text-end">{{user.worked_minutes | minutes:false}}</td>
                                        <td [class.text-danger]="user.balance_minutes < 0" class="text-end">{{user.balance_minutes | minutes:false}}</td>
                                        @for (year of user.years; track $index) {
                                            @if (year) {
                                                <td class="text-end">{{year.vacation_minutes | minutes:false}}</td>
                                                <td class="text-end">{{year.sick_minutes | minutes:false}}</td>
                                                <td [class.text-danger]="year.balance_minutes < 0" class="text-end">{{year.balance_minutes | minutes:false}}</td>
                                            } @else {
                                                <td class="text-end">—</td>
                                                <td class="text-end">—</td>
                                                <td class="text-end">—</td>
                                            }
                                        }
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <small class="text-muted">
                        Uren vanaf de datum in dienst t/m vandaag. Balans is geregistreerde uren min contracturen, net als in de rapportage;
                        de balans per jaar volgt de weeknummers (ISO-jaar), net als de jaarkeuze in de rapportage.
                    </small>
                } @else {
                    <p>Laden…</p>
                }
            </div>
        </div>
    }
</div>
